const getSafeMessageOrFallback = (intl, message, fallbackMessage) => {
  try {
    return intl.formatMessage(message);
  } catch (error) {
    return fallbackMessage ? getSafeMessageOrFallback(intl, fallbackMessage) : null;
  }
};

const textWithFallback = (formattedText, fallbackMessage, fallbackText) => {
  if (formattedText) {
    return formattedText;
  }
  if (fallbackMessage && fallbackMessage.defaultMessage) {
    return fallbackMessage.defaultMessage;
  }
  return fallbackText || '';
};

const getMessageText = (intl, { message, fallbackMessage = {}, fallbackText = '' }) => {
  const formatted = getSafeMessageOrFallback(intl, message, fallbackMessage);
  return formatted || textWithFallback(fallbackText, fallbackMessage, fallbackMessage.defaultMessage);
};

export { getMessageText };
